import React from 'react';

import Button, { ButtonProps } from '../buttons/Button';

export default function NoListButton({ children, ...props }: ButtonProps) {
  return (
    <Button variant="line" color="gray" size="md" {...props}>
      {children}
    </Button>
  );
}
